/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterJSmall = createReactComponent("outline", "letter-j-small", "IconLetterJSmall", [["path", { "d": "M10 8h4v6a2 2 0 1 1 -4 0", "key": "svg-0" }]]);

export { IconLetterJSmall as default };
//# sourceMappingURL=IconLetterJSmall.mjs.map
